import { getYoutubeEmbedUrl } from "@/utils/youtube";
import React from "react";

export default function YoutubePlayer({url}) {
  return (
    <iframe
      width="100%"
      height="400"
      src={getYoutubeEmbedUrl(url)}
      // src={`https://www.youtube.com/embed/${currentVideoId}?autoplay=1`}
      title="Student Video Review"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  );
}
